module.exports = __webpack_public_path__ + "img/antes_despues_166.304f97c4.png";